import { render, staticRenderFns } from "./OrderSlider.vue?vue&type=template&id=23424644&scoped=true&"
import script from "./OrderSlider.vue?vue&type=script&lang=js&"
export * from "./OrderSlider.vue?vue&type=script&lang=js&"
import style0 from "./OrderSlider.vue?vue&type=style&index=0&id=23424644&lang=scss&scoped=true&"
import style1 from "./OrderSlider.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23424644",
  null
  
)

export default component.exports